const DATA_LINK_ACTIONS = {
  DATA_LINKS_LOADED: 'DATA_LINKS_LOADED',
  DATA_LINK_DOCUMENTS_LOADED: 'DATA_LINK_DOCUMENTS_LOADED',
  DATA_LINK_DOCUMENTS_APPENDED: 'DATA_LINK_DOCUMENTS_APPENDED',
  DATA_LINK_DOCUMENT_SELECTED: 'DATA_LINK_DOCUMENT_SELECTED',
  DATA_LINK_DOCUMENT_DESELECTED: 'DATA_LINK_DOCUMENT_DESELECTED',
  DATA_LINK_PARAMETERS_SET: 'DATA_LINK_PARAMETERS_SET',
  DATA_LINK_DOCUMENTS_COUNTED: 'DATA_LINK_DOCUMENTS_COUNTED'
};

const dataLinksLoadedAction = dataLinks => {
  return {
    type: DATA_LINK_ACTIONS.DATA_LINKS_LOADED,
    payload: dataLinks
  };
};

const dataLinkDocumentsLoadedAction = ({ dataLinkId, documents }) => {
  return {
    type: DATA_LINK_ACTIONS.DATA_LINK_DOCUMENTS_LOADED,
    payload: { dataLinkId, documents }
  };
};

const dataLinkDocumentsAppendedAction = ({ dataLinkId, documents }) => {
  return {
    type: DATA_LINK_ACTIONS.DATA_LINK_DOCUMENTS_APPENDED,
    payload: { dataLinkId, documents }
  };
};

const dataLinkDocumentsCountedAction = ({ dataLinkId, count }) => {
  return {
    type: DATA_LINK_ACTIONS.DATA_LINK_DOCUMENTS_COUNTED,
    payload: { dataLinkId, count }
  };
};

const dataLinkDocumentSelectedAction = ({ dataLinkId, documentId }) => {
  return {
    type: DATA_LINK_ACTIONS.DATA_LINK_DOCUMENT_SELECTED,
    payload: { dataLinkId, documentId }
  };
};

const dataLinkDocumentDeSelectedAction = ({ dataLinkId }) => {
  return {
    type: DATA_LINK_ACTIONS.DATA_LINK_DOCUMENT_DESELECTED,
    payload: { dataLinkId }
  };
};

export {
  DATA_LINK_ACTIONS,
  dataLinksLoadedAction,
  dataLinkDocumentsLoadedAction,
  dataLinkDocumentSelectedAction,
  dataLinkDocumentDeSelectedAction,
  dataLinkDocumentsCountedAction,
  dataLinkDocumentsAppendedAction
};
